const modul = {
	namespaced: true,

	state: {
		radtexterVisas: true,	// = initialt defaultvärde
		rattelserVisas: false,		// = initialt defaultvärde

		rullningsbaraElement: [ 	// = initiala defaultvärden
			{ id:'re1', scrollTop: 0 }
		]
	},

	mutations: {

		setRadtexterVisas(state, nyttVarde)
		{
			// `state` is the local module state
			state.radtexterVisas = nyttVarde;
		},

		setRattelserVisas(state, nyttVarde)
		{
			// `state` is the local module state
			state.rattelserVisas = nyttVarde;
		}

		// rullningsbaraElement muteras via en "root mutation" som används av flera modules/namespaces:
	}

	//actions: { ... },

	//getters: { ... }
};

export { modul as ssoStatestoreVerifikat };
